import { apiInstance, gql } from "@/services/httpAdapter";

import { SaleInvoiceFragment } from "./fragments";

const EMPTY_RESULT = { edges: [], pageInfo: { hasNextPage: false, endCursor: "", totalCount: 0 } };

export async function getSalesInvoices(filter, pagination) {
	const query = gql`
		query getSalesInvoices($filter: GetSalesInvoicesFilterInput!, $pagination: PaginationInput) {
			getSalesInvoices(filter: $filter, pagination: $pagination) {
				edges {
					cursor
					node {
						...SaleInvoice
					}
				}
				pageInfo {
					endCursor
					hasNextPage
					totalCount
				}
			}
		}
		${SaleInvoiceFragment}
	`;

	const variables = { filter, pagination };

	const response = await apiInstance.post("/graphql", { query, variables });
	return response?.data?.data?.getSalesInvoices || EMPTY_RESULT;
}

export async function uploadChargebacks(locationId, commissionCycleId, file) {
	try {
		if (locationId && commissionCycleId) {
			const query = gql`
				query getChargebacksPresignedUrl($locationId: String!, $commissionCycleId: String!) {
					getChargebacksPresignedUrl(locationId: $locationId, commissionCycleId: $commissionCycleId) {
						fileName
						presignedUrl
					}
				}
			`;

			const variables = {
				locationId,
				commissionCycleId,
			};

			const response = await apiInstance.post("/graphql", { query, variables });

			const presigned = response.data?.data?.getChargebacksPresignedUrl;
			if (presigned) {
				let fileName = presigned?.fileName;
				let uploadFile = new File([file], fileName);

				const options = {
					headers: {
						"Content-Type": file.type,
					},
				};
				const upload = await apiInstance.put(presigned?.presignedUrl, uploadFile, options);
				if (upload.status === 200) {
					return true;
				}

				return {
					status: false,
					message: `Some error occurred`,
				};
			}
		}
	} catch (error) {
		return {
			status: false,
			message: `${error.message}`,
		};
	}
}
